module.exports = __webpack_public_path__ + "img/_DSC8200-min.fe9c99d6.jpg";